import {Conversation} from '@app/core/models/conversation.model';
import {Message} from '@app/core/models/message.model';
import {Pagination} from '@app/core/models/pagination.model';
import {FileEntry} from '@app/core/models/fileEntry.model';

export interface IMessagesState {
	isMessagesLoading: boolean;
	isConversationsLoading: boolean;
	isLoadingSendingMessage: boolean;
	pagination: Pagination;
	conversations: Conversation[];
	filteredConversations: Conversation[];
	messages: Message[];
	messageFileEntries: FileEntry[];
	createNewConversation: boolean;
	selectedConversation: Conversation;
	showOnlyMessages: boolean;
}

export const initialMessagesState: IMessagesState = {
	isMessagesLoading: false,
	isConversationsLoading: false,
	isLoadingSendingMessage: false,
	conversations: [],
	filteredConversations: [],
	pagination: undefined,
	messages: [],
	messageFileEntries: [],
	createNewConversation: false,
	selectedConversation: undefined,
	showOnlyMessages: false,
};
